/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2024-07-05 17:34:13
 */
import React from 'react'
import { Modal, message, Upload } from 'antd'
import Excel from 'exceljs'
import { useAppDispatch } from '../../../../app/hooks'
import { setLoading } from '../../../../actions/main'
import { InboxOutlined } from '@ant-design/icons'
const { Dragger } = Upload

interface CustomerLocation {
  customerName: string
  address: string
  contractName: string
  contractTelPhone: string
  ownerMobiles: string[]
}

interface UploadProps {
  getLocationsByAddress: (locations: CustomerLocation[]) => void
  fileList: any[]
  setFileList: (files: any[]) => void
}

export default ({
  getLocationsByAddress,
  fileList,
  setFileList
}: UploadProps) => {
  const dispatch = useAppDispatch()

  const clearPage = () => {
    setFileList([])
  }

  const getCellPlainValue = (value) => {
    if (typeof value === 'string' || typeof value === 'number') {
      return value.toString()
    }
    if (typeof value === 'object' && value.richText) {
      let texts = value.richText.map((richText) => richText.text)
      return texts.join('')
    }
    return ''
  }

  const parseExcel = async (file: File) => {
    let workbook = new Excel.Workbook()
    let reader = new FileReader()
    reader.onloadend = function () {
      let arrayBuffer = reader.result as ArrayBuffer
      workbook.xlsx.load(arrayBuffer).then(function (workbook) {
        let locations: CustomerLocation[] = []
        let sheet = workbook.getWorksheet(1)
        if (!sheet) {
          Modal.error({
            title:
              '解析不到文件内的数据，请下载模板，按照模板填写成员信息后提交',
            onOk: clearPage
          })
        } else {
          if (sheet.actualRowCount <= 2) {
            Modal.error({
              title: '表格中无数据，请按照模板填写成员信息后提交。',
              onOk: clearPage
            })
            return false
          }
          if (sheet.actualRowCount > 3002) {
            Modal.error({
              title: '一次最多导入3000个地点！',
              onOk: clearPage
            })
          } else {
            dispatch(setLoading(true))

            workbook.worksheets[0].eachRow(function (row, rowNumber) {
              if (rowNumber > 2) {
                let customerName = row.values[1]
                  ? getCellPlainValue(row.values[1])
                  : ''
                let address = row.values[2]
                  ? getCellPlainValue(row.values[2])
                  : ''
                let ownerMobiles = row.values[3]
                  ? getCellPlainValue(row.values[3])
                  : ''
                let contractName = row.values[4]
                  ? getCellPlainValue(row.values[4])
                  : ''
                let contractTelPhone = row.values[5]
                  ? getCellPlainValue(row.values[5])
                  : ''

                customerName = customerName.trim().replace(/\n/g, '')
                address = address.trim().replace(/\n/g, '')
                contractName = contractName.trim().replace(/\n/g, '')
                contractTelPhone = contractTelPhone.trim().replace(/\n/g, '')
                ownerMobiles = ownerMobiles.trim().replace(/\n/g, '')

                locations.push({
                  customerName: customerName,
                  address: address,
                  contractName: contractName,
                  contractTelPhone: contractTelPhone,
                  ownerMobiles: ownerMobiles.split('、')
                })
              }
            })

            //数据解析完成调用函数传递列表
            getLocationsByAddress(locations)
          }
        }
      })
    }
    reader.readAsArrayBuffer(file)
  }

  const beforeUpload = (file) => {
    const isExcelFile =
      file.type ===
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
      file.type === 'application/vnd.ms-excel'

    if (!isExcelFile) {
      message.error('文件格式错误，仅支持xls、xlsx文件！')
    } else if (file.size / 1024 / 1024 > 100) {
      message.error('上传文件过大，文件最大支持100MB！')
    } else {
      setFileList([file])

      parseExcel(file)
    }
    return false
  }

  const uploadProps = {
    accept:
      'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    name: 'file',
    multiple: false,
    beforeUpload,
    onRemove: clearPage,
    fileList
  }

  return (
    <Dragger {...uploadProps}>
      <div className="upload-drag-wrapper">
        <InboxOutlined
          style={{
            fontSize: 48,
            color: '#1890FF'
          }}
        />
        <p className="upload-text">点击选择文件或将文件拖拽至此处上传</p>
        <p className="upload-hint">仅支持xls、xlsx格式文件</p>
      </div>
    </Dragger>
  )
}
